module.exports = {"platforms":[{"type":"FiniteImmobilePlatform","x":128,"y":64,"width":192,"height":32,"display":{"assetName":"test"}},{"type":"FiniteImmobilePlatform","x":32,"y":384,"width":192,"height":32,"display":{"assetName":"test"}},{"type":"InfiniteRectangularPlatform","x":800,"y":100,"width":-256,"height":256,"direction":"horizontal","display":{"assetName":"test"}}],"goal":{"x":700,"y":100},"player":{"x":160,"y":180}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/test2.json
// module id = 154
// module chunks = 0